<template>
  <a-modal title="处方详情" :width="1200" :visible="visible" :maskClosable="false" v-if="hackReset" @cancel="handleCancel">
    <template slot="footer">
      <a-button @click="handleCancel">
        取消
      </a-button>

      <a-button type="primary" :loading="confirmLoading" @click="handleSubmit" v-show="this.isHow">
        保存
      </a-button>
    </template>
    <div class="viewDetial-tiem">
      <a-form :form="form">

        <a-row :gutter="24">
          <a-row :gutter="24">
            <a-col :md="8">
              <a-form-item label="医院名称" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.orgName" allow-clear placeholder="请输入医院名称" />
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item label="医疗结构编码" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.orgCode" allow-clear placeholder="请输入医疗机构编码" />
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item label="卫生机构类别" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-tree-select v-model="form.orgType" style="width: 200px"
                  :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="parentOptions"
                  placeholder="请先选择医院">
                </a-tree-select>
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="8">
              <a-form-item label="医院等级" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <!-- <a-input v-model="form.realName" allow-clear placeholder="请输入姓名" /> -->
                <a-select v-model="form.orgLevel" style="width: 100px;margin-right: 3px;" placeholder="请选择">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="1">一级</a-select-option>
                  <a-select-option value="2">二级</a-select-option>
                  <a-select-option value="3">三级</a-select-option>
                  <a-select-option value="4">未定级</a-select-option>
                </a-select>
                <a-select v-model="form.orgGrade" style="width: 100px" placeholder="请选择">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="5">特等</a-select-option>
                  <a-select-option value="6">甲等</a-select-option>
                  <a-select-option value="7">乙等</a-select-option>
                  <a-select-option value="8">丙等</a-select-option>
                  <a-select-option value="9">未定等</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item label="成立日期" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-date-picker allow-clear format="YYYY-MM-DD" placeholder="请选择成立日期" @change="handelDate" />
              </a-form-item>

            </a-col>
            <a-col :md="8">
              <!-- <a-form-item label="注册资金" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.realName" allow-clear placeholder="请输入注册资金" />
              </a-form-item> -->
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="8">
              <a-form-item label="医院负责人" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.linkman" allow-clear placeholder="请输入医院负责人" />
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item label="医院联系电话" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.phone" allow-clear placeholder="请输入医院联系电话" />
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <!-- <a-form-item label="医院法定代表人" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.linkman" allow-clear placeholder="请输入医院法定代表人" />
              </a-form-item> -->
            </a-col>
          </a-row>

          <!-- <a-row :gutter="24">
            <a-col :md="8">
              <a-form-item label="医院官网" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.realName" allow-clear placeholder="请输入医院官网地址" />
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item label="是否具备家庭病床" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.realName" allow-clear placeholder="请选择是否具备家庭病床" />
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item label="是否具备巡视服务" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <a-input v-model="form.realName" allow-clear placeholder="请选择是否具备巡视服务" />
              </a-form-item>
            </a-col>
          </a-row> -->

          <a-row :gutter="24">
            <a-col :md="6">
              <a-form-item label="医院行政区划" :labelCol="{xs: { span: 24 },sm: { span: 10 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 14 }}">
                <!-- <a-input v-model="form.provId" allow-clear placeholder="请选择省" /> -->
                <a-select v-model="form.provId" placeholder="请选择省" :options="areaList"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4">
              <a-form-item label="" :labelCol="{xs: { span: 24 },sm: { span: 0 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 24 }}">
                <!-- <a-input v-model="form.cityId" allow-clear placeholder="请选择市" /> -->
                <a-select v-model="form.cityId" placeholder="请选择市" :options="cityList"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="4">
              <a-form-item label="" :labelCol="{xs: { span: 24 },sm: { span: 0 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 24 }}">
                <!-- <a-input v-model="form.distId" allow-clear placeholder="请选择区" /> -->
                <a-select v-model="form.distId" placeholder="请选择县" :options="distList"></a-select>
              </a-form-item>
            </a-col>
            <a-col :md="10">
              <a-form-item label="" :labelCol="{xs: { span: 24 },sm: { span: 0 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 24 }}">
                <a-input v-model="form.address" allow-clear placeholder="请输入详细地址" />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="8">
              <a-form-item label="医院logo" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <img v-if="type == 1" style="width:200px;height:200px" :src="form.orgLogoUrl" alt="">
                <a-upload v-else name="avatar" list-type="picture-card" class="avatar-uploader"
                  :show-upload-list="false" :customRequest="fileUpdate" :before-upload="beforeUpload">
                  <img v-if="imageUrl" style="width:162px;height:162px" :src="imageUrl" alt="">
                  <div v-else>
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="ant-upload-text">
                      Upload
                    </div>
                  </div>
                </a-upload>
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item label="" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <!-- <a-input v-model="form.realName" allow-clear placeholder="请输入姓名" /> -->
              </a-form-item>
            </a-col>
            <a-col :md="8">
              <a-form-item label="" :labelCol="labelCol_two" :wrapperCol="wrapperCol">
                <!-- <a-input v-model="form.realName" allow-clear placeholder="请输入姓名" /> -->
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="24">
            <a-col :md="24">
              <a-form-item label="简介" :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
                :wrapperCol="{xs: { span: 24 },sm: { span: 21 }}">
                <a-textarea v-model="form.orgIntroduction" showCount :rows="6" placeholder="请输入简介" />
              </a-form-item>
            </a-col>
          </a-row>
        </a-row>

      </a-form>
    </div>
  </a-modal>
</template>

<script>
  import { STable } from '@/components';
  import moment from 'moment'
import { getOrgList, getArea, pictureUpdate, medicalOrgEdit } from '@/api/modular/interhospital/medicalOrg/medicalOrgManage'
  export default {
    components:{
      STable
    },
    data () {
      return {
        queryParam : {},
        visible: false,
        hackReset : true,
        isHow : false,
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        labelCol_two: {
          xs: { span: 24 },
          sm: { span: 11 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 13 }
        },
        // 卫生机构
        parentOptions : [],
        
        confirmLoading: false,
        form: {},
        areaList : [],
        cityList: [],
        distList : [],

        // 文件上传
        imageUrl: '',
        type: '',
        loading: false,
      }
    },
    methods: {
      moment,
      // 初始化方法
      add(record, isHow) {
        console.log('record',record)
        this.form = {};

        if (isHow) {
          this.type=2
        } else {
          this.type=1
        }
        
        this.isHow = isHow;
        this.form = Object.assign({}, record) ;
        this.visible = true;

        // 获取卫生机构
        this.queryOrgList();
        // 获取省
        this.queryArea();
        // 获取市
        this.queryCity(record.provProId);
        // 获取县
        this.queryDist(record.cityProId);

      },

      //点击取消按钮
      handleCancel () {
        this.form = {};
        this.visible = false;
        this.hackReset = false;
        this.$nextTick(()=>{
          this.hackReset = true;
          this.form = {};
        })
      },

      // 保存按钮
      handleSubmit() {
        let { orgName, orgCode, orgType, orgLevel, orgGrade, openDatetime, linkman, phone, provId, cityId, distId, address, orgLogoUrl, orgIntroduction, orgId, remark } = this.form
        let params = {
          orgName,
          orgCode,
          orgType,
          orgLevel,
          orgGrade,
          openDatetime,
          linkman,
          phone,
          provId,
          cityId,
          distId,
          address,
          orgLogoUrl,
          orgIntroduction,
          orgId,
          remark
        };
        console.log(params)
        medicalOrgEdit(params).then(res => {
          console.log(res)
          if (res.code == 200) {
            this.$message.success('编辑成功');
            this.form = {};
            this.visible = false;
            this.$parent.handleOk();
          } else {
            this.$message.error('编辑失败');
          }
        })
      },

      // 获取省
      async queryArea(parentId) {
        let params = {
          parentId : ''
        };
        await getArea(params).then(res => {
          if (res.code == 200) {
            this.areaList = [];
            res.data.map(item => {
              this.areaList.push({
                label: item.areaName,
                value: item.areaCode
              })
            })
          }

        })

      },
      // 获取市
      async queryCity(parentId) {
        let params = {
          parentId,
        };

        await getArea(params).then(res => {
          if (res.code == 200) {
            this.cityList = [];
            res.data.map(item => {
              this.cityList.push({
                label: item.areaName,
                value: item.areaCode
              })
            })
          }

        })

      },
      // 获取县
      async queryDist(parentId) {
        let params = {
          parentId,
        };

        await getArea(params).then(res => {
          if (res.code == 200) {
            this.distList = [];
            res.data.map(item => {
              this.distList.push({
                label: item.areaName,
                value: item.areaCode
              })
            })
          }

        })

      },
      
      // 获取卫生机构类别
      async queryOrgList() {
        let params = {
          dictId : '10'
        }
        await getOrgList(params).then(res => {
          if (res.code == 200) {
            this.parentOptions = this.recursion(res.data);
          }
        })
      },
      recursion(arr) {
        arr.forEach((item, index) => {
          if (item.childDatadictDetailList instanceof Array) {
            arr[index] = {
              title: item.detailName,
              value: item.valueId,
              children: item.childDatadictDetailList
            }
            this.recursion(item.childDatadictDetailList)
          } else {
            arr[index] = {
              title: item.detailName,
              value: item.valueId,
              children: []
            }
          }

        })
        return arr
      },
      // 成立日期
      handelDate(date, dateString) {
        this.form.openDatetime = dateString;
      },
      // 自定义文件上传
      beforeUpload(file) {
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
          this.$message.error('建议上传图片大小不超过2MB!');
        }
        return isLt2M;
      },
      fileUpdate(file) {
        const form = new FormData();
        form.append('file', file.file);
        pictureUpdate(form).then(res => {
          if (res.code == 200) {
            this.form.orgLogoUrl = res.data;
            this.imageUrl = res.data;
          } else {
            this.$message.error('上传图片失败')
          }
        })
      }
     
    },
  }
</script>
<style lang="less" scoped>
.viewDetial-title{
  height: 40px;
  line-height: 40px;
  font-family: "PingFang SC ", "PingFang SC", sans-serif;
  font-weight: 650;
  font-style: normal;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.847);
  margin-bottom: 20px;
}
/deep/.s-table-tool{
  display: none;
}
.totalPrice{
  line-height: 30px;
  padding: 0 30px;
}
.detialImage{
  width: 80px;
  height: 30px;
  margin: 0 10px;
  cursor: pointer;
  
  // transform: rotate();
}
</style>
